
// Method 4: Override video play method to ensure muting
const originalPlay = HTMLVideoElement.prototype.play;
HTMLVideoElement.prototype.play = function() {
    this.muted = true;
    this.volume = 0;
    return originalPlay.call(this);
};